import { VBadge } from 'vuetify/lib/components/VBadge';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.isPageAttributes
        ? _c(
            VTooltip,
            {
              attrs: { bottom: "" },
              scopedSlots: _vm._u(
                [
                  {
                    key: "activator",
                    fn: function (ref) {
                      var on = ref.on
                      var attrs = ref.attrs
                      return [
                        _c(
                          VBadge,
                          {
                            attrs: {
                              bordered: "",
                              content: _vm.selectedAttributes,
                              value: _vm.selectedAttributes,
                              overlap: "",
                              "offset-x": "22",
                              "offset-y": "22",
                            },
                          },
                          [
                            _c(
                              VBtn,
                              _vm._g(
                                _vm._b(
                                  {
                                    key: _vm.selectedAttributes,
                                    class: {
                                      "disable-events":
                                        _vm.selectedAttributes === 0,
                                      "btn-animado": _vm.selectedAttributes > 0,
                                    },
                                    attrs: { icon: "", color: "primary" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.$router.push({
                                          name: "attributes_selected",
                                        })
                                      },
                                    },
                                  },
                                  "v-btn",
                                  attrs,
                                  false
                                ),
                                on
                              ),
                              [
                                _c(VIcon, [
                                  _vm._v("mdi-checkbox-marked-circle-outline"),
                                ]),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ],
                null,
                false,
                4105718387
              ),
            },
            [
              _c("span", [
                _vm._v(
                  _vm._s(
                    _vm.$t("titles.selected_attributes") +
                      ": " +
                      _vm.selectedAttributes
                  )
                ),
              ]),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }